import { createContext } from 'react';
import { FingerprintContextProps } from './types';

export const FingerprintContext = createContext<
  Promise<FingerprintContextProps>
>({} as Promise<FingerprintContextProps>);
